import { TableCell, TableHead } from "@/common/components";
import { cn } from "@/common/lib/utils";

interface StyledTableHeadProps extends React.HTMLAttributes<HTMLTableCellElement> {
  rowSpan?: number;
  colSpan?: number;
}

export const StyledTableHead = ({
  children,
  rowSpan,
  colSpan,
  className,
  ...props
}: StyledTableHeadProps) => (
  <TableHead
    className={cn("text-left p-3 md:p-4", className)}
    rowSpan={rowSpan}
    colSpan={colSpan}
    {...props}
  >
    {children}
  </TableHead>
);

export const StyledTableCell = ({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableCellElement>) => (
  <TableCell className={cn("text-left p-3 md:p-4", className)} {...props}>
    {children}
  </TableCell>
);
